// L'onglet Citations de la fiche d'une personnalité (15 octobre 2026).
// Jamais de genre deviné : « Ce qu’on en dit », jamais « d’elle ».
export default {
  filtres: {
    aria: 'Filtrer les citations',
    qui: 'Qui parle',
    toutes: 'Toutes',
    ou: 'Où',
    partout: 'Partout',
    sujet: 'Sujet',
    tous: 'Tous',
    periode: 'Période',
    j7: '7 jours',
    j30: '30 jours',
    tout: 'Depuis le suivi',
  },
  compte: '{n} citation {periode}, avec sa source, sa date et son heure | {n} citations {periode}, chacune avec sa source, sa date et son heure',
  periodeCompte: { j7: 'sur 7 jours', j30: 'sur 30 jours', tout: 'depuis le suivi' },
  jour: { aujourdhui: 'Aujourd’hui, {jour}', hier: 'Hier, {jour}' },
  voirPlus: 'Voir plus',
  chargement: 'Chargement des citations…',
  vide: 'Aucune citation sur cette période',
  exporter: 'Exporter',
  exportEnCours: 'Export en cours…',
  erreurExport: 'L’export n’a pas abouti.',
  csv: {
    date: 'Date',
    heure: 'Heure (Paris)',
    genre: 'Qui parle',
    plateforme: 'Plateforme',
    auteur: 'Auteur',
    media: 'Média',
    sujet: 'Sujet',
    position: 'Position',
    sens: 'Sens',
    extrait: 'Extrait',
    source: 'Adresse de la source',
    releve: 'Relevée le',
  },
}
